<template>
  <div>
    <account-summary-detail />
  </div>
</template>

<script>
import AccountSummaryDetail from './AccountSummaryDetail.vue';
import '../contact/styleguide.css'

export default {
  components: {
    AccountSummaryDetail,
  },
};
</script>

<style scoped></style>
